import React from "react";

import { Column, Row } from "@gamedev-web/gamedev-sdk-core";

import {
  EmailBox,
  EmailDropdownProps,
  MiddlewarePartnerDropdown,
  MiddlewarePartnerDropdownProps,
  NameBox,
  SellerDropdown,
  SellerDropdownProps,
  UnauthorizedSellersList,
} from "../../../components/GdkMiddlewareRequest";
import {
  emailLabel,
  gameDeveloperPublisher,
  gdkRequestNote,
  gdkRequestNoteLink,
  middlewarePartner,
  name,
} from "../gdkMiddlewarePageContent";
import * as styles from "../GdkMiddlewareRequestPage.module.css";

const documentationLink =
  "https://learn.microsoft.com/gaming/game-publishing/resources/tools-and-middleware-partners";

export type MainRequestStepProps = SellerDropdownProps &
  MiddlewarePartnerDropdownProps &
  EmailDropdownProps;

export const MainRequestStep = ({
  currentSeller,
  setCurrentSeller,
  currentMiddleware,
  setCurrentMiddleware,
  email,
  setEmail,
}: MainRequestStepProps) => (
  <>
    <span className={styles.gdkMainText}>
      {gdkRequestNote}
      <a href={documentationLink} target="_blank" rel="noreferrer" className={styles.gdkLink}>
        {gdkRequestNoteLink}
      </a>
    </span>
    <Row>
      <Column className={styles.fieldsColumn}>
        <label className={styles.gdkLabel}>{middlewarePartner}</label>
        <MiddlewarePartnerDropdown
          currentMiddleware={currentMiddleware}
          setCurrentMiddleware={setCurrentMiddleware}
        />
        <br />
        <label className={styles.gdkLabel}>{name}</label>
        <NameBox />
      </Column>
      <Column className={styles.fieldsColumn}>
        <label className={styles.gdkLabel}>{gameDeveloperPublisher}</label>
        <SellerDropdown currentSeller={currentSeller} setCurrentSeller={setCurrentSeller} />
        <br />
        <label className={styles.gdkLabel}>{emailLabel}</label>
        <EmailBox email={email} setEmail={setEmail} />
      </Column>
      <UnauthorizedSellersList />
    </Row>
  </>
);
